import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

type CreditBalanceResponse = {
  balance: number;
};

export function useCreditBalance(enabled = true) {
  return useQuery({
    queryKey: ['creditBalance'],
    queryFn: () => apiClient<CreditBalanceResponse>('/users/me/credit'),
    enabled,
  });
}
